import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';

import './assets/font/fonts.css';
import { redactTokensFromEvent } from 'helpers/sentryScrubbing';

Sentry.init({
    dsn: window.__TOTENV__.SENTRY_DSN,
    environment: window.__TOTENV__.ENV,
    maxValueLength: 1000,
    normalizeDepth: 6,
    beforeSend: redactTokensFromEvent,
});

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
